import moment from 'moment'
import React from 'react'
import styled from 'styled-components'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import { color } from 'styles/colors'
import _ from 'underscore'

type Props={
  label: string
  value:string
  onChangeCallback: (value)=>void
}
const DatePickerComponent = ({ label, value, onChangeCallback }: Props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <S.DatePicker
        className="DatePicker"
        label={label}
        value={_.isEmpty(value) ? null : moment(value)}
        onChange={(newDate) => onChangeCallback(newDate)}
      />
    </LocalizationProvider>
  )
}

export default DatePickerComponent

const S = {
  DatePicker: styled(DatePicker)`
  font-family: Inter, sans-serif;
  &:hover{
    border: 0px;
  }

  & .MuiInputBase-root {
    border: 1px solid ${color('datePickerBorder')};
    border-radius: 4px !important;
  }

  & .MuiInputBase-root:hover{
   border: 1px solid ${color('datePickerBorder')};
  }

  & .MuiInputLabel-formControl{
    color: ${color('primaryText')};
    font-weight: 400;
    font-size: 16px;
    font-family: Inter, sans-serif;
    border-width: 0px !important;
  }

  & .MuiFormLabel-filled, & .MuiInputLabel-root.Mui-focused{
    top: -12px;
  }

  & .MuiOutlinedInput-input:hover {
    border: 0px solid ${color('datePickerHover')};
    border-radius: 10px;
  }

  & .MuiOutlinedInput-input:focus {
    border: 0px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  & .MuiOutlinedInput-notchedOutline{
    inset: -1px 0px 0px;
  }

  & .MuiOutlinedInput-notchedOutline > legend{
    display: none;
  }

  &:hover .not(.Mui-errror) .MuiOutlinedInput-notchedOutline{
    border: 1px solid ${color('datePickerHover')};
    border-radius: 10px;
  }

  & .MuiInputLabel-root.Mui-focused {
    border: 1px solid ${color('datePickerLableText')};
    border-right: 0px;
  }

  .DatePicker input:focus{
    border: none;
  }
 `
}
